import React from "react";
import { geometryType } from "./AddCoordinateToolBar";

export default function SavedLine(props) {
  if (props.line.type !== geometryType.POLYLINE) return null;
  const distance = `|${props.line.alongRoadDistance.toFixed(2)}m`;

  return props.isSameRoad ? (
    <span className="geometryLabel">
      {`${props.line.startRoadNo} ${props.line.startRoadName} ${
        props.hasSlk
          ? `${props.line.startSLK} - ${props.line.endSLK} ${distance}`
          : `[${props.line.startLatitude},${props.line.startLongitude}] - [${props.line.endLatitude},${props.line.endLongitude}] ${distance}`
      }`}
    </span>
  ) : (
    <span className="geometryLabel">
      {`${props.line.startRoadNo} ${props.line.startRoadName}/${
        props.line.endRoadNo
      } ${props.line.endRoadName} ${
        props.hasSlk
          ? `${props.line.startSLK} - ${props.line.endSLK} ${distance}`
          : `[${props.line.startLatitude},${props.line.startLongitude}] [${props.line.endLatitude},${props.line.endLongitude}] ${distance}`
      }`}
    </span>
  );
}
